import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { formatDate } from './FieldComponents';
import { getContactInitialsClassName } from '../utils/colorUtils';
import { EntityHoverPreview } from './EntityHoverPreview';

export const LeadRelatedCases = ({ relatedCases, contact, phases = [], primaryAttorney }) => {
    const [primaryAttorneyName, setPrimaryAttorneyName] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (primaryAttorney) {
            fetchPrimaryAttorney();
        }
    }, [primaryAttorney]);

    if (!relatedCases || relatedCases.length === 0) {
        return (
            <div className="lead-related-cases case-section">
                <div className='toc-header'>
                    <h3>Related Cases</h3>
                </div>
                <div className="no-cases">
                    <p className='subtext nm'>No related cases found for this lead.</p>
                </div>
            </div>
        );
    }

    const fetchPrimaryAttorney = async () => {
        const response = await fetch(`https://api.casedb.co/contacts.php?id=${primaryAttorney}`, { credentials: 'include' });
        const data = await response.json();
        if (data.success) {
            setPrimaryAttorneyName(data.contacts?.full_name || data.contacts?.name || 'Unknown');
        } else {
            console.error("Error fetching primary attorney:", data.message);
            return null;
        }
    }

    const getContactDisplay = (caseItem) => {
        if (contact?.profile_picture) {
            return <img src={`https://api.casedb.co/${contact.profile_picture}`} alt="Profile" className="contact-initials" />;
        }
        
        const initials = contact.first_name?.trim().charAt(0) + contact?.last_name?.trim().charAt(0) || "DB";
        const className = getContactInitialsClassName('mini-case-initials', caseItem.id);
        
        return <span className={className}>{initials}</span>;
    };

    return (
        <div className="lead-related-cases case-section">
            <div className='toc-header'>
                <h3>Related Cases</h3>
            </div>
            <div className="cases-list">
                {relatedCases.map((caseItem) => (
                    <EntityHoverPreview
                        as="div"
                        entityType="case"
                        entityId={caseItem.id}
                        className="mini-case-summary"
                        onClick={() => navigate(`/case/${caseItem.id}`)}
                        key={caseItem.id}
                    >
                        <div className='mini-case-initials'>
                            {getContactDisplay(caseItem)}
                        </div>
                        <div className="mini-case-meta">
                            <div className="mini-case-name">
                                {caseItem.case_name}
                                <span className='subtext'>
                                    ({caseItem.id})
                                </span>
                            </div>
                            <div className='mini-case-info subtext'>
                                <span>{formatDate(caseItem.create_date)[0]}</span>
                                <span>{phases.find(p => p.id === caseItem.phase_id).phase}</span>
                                {primaryAttorney && <span>{primaryAttorneyName}</span>}
                            </div>
                        </div>
                    </EntityHoverPreview>
                ))}
            </div>
        </div>
    );
};
